import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { LOGIN } from '../constants/routes';
import { SocketProvider } from 'views/Profile/Chat/contexts/SocketProvider';
import { ConversationsProvider } from 'views/Profile/Chat/contexts/ConversationsProvider';
import { ContactsProvider } from 'views/Profile/Chat/contexts/ContactsProvider';
import Loader from './Loader/Loader';

const PrivateRoute = ({ children, ...rest }) => {
  const {
    auth: { isAuthenticated, loading, user },
  } = useSelector((state) => {
    return {
      auth: state.auth,
    };
  }, shallowEqual);

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated && !loading ? (
          <Redirect to={LOGIN} />
        ) : (
          <>
            {user === null ? (
              <Loader />
            ) : (
              <SocketProvider id={user._id}>
                <ContactsProvider>
                  <ConversationsProvider id={user._id}>
                    {children}
                  </ConversationsProvider>
                </ContactsProvider>
              </SocketProvider>
            )}
          </>
        )
      }
    />
  );
};

export default PrivateRoute;
